export enum NotificationPurchaseFilterEnum {
  ALL = "all",
  PURCHASE = "purchase",
  NO_PURCHASE = "no_purchase",
}
